import { render } from "./Buildable.vue?vue&type=template&id=859b5fb2"
import script from "./Buildable.vue?vue&type=script&lang=js"
export * from "./Buildable.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__